import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TextServiceProvider } from '../modules/core/services/text-service/text-service';

@Injectable()
export class MatPaginatorI18n extends MatPaginatorIntl {
  public itemsPerPageLabel = this.textService.get('itemsPerPageLabel') || 'Liczba elementów na stronie';
  public nextPageLabel = this.textService.get('nextPageLabel') || '';
  public previousPageLabel = this.textService.get('previousPageLabel') || '';
  public firstPageLabel = this.textService.get('firstPageLabel') || '';
  public lastPageLabel = this.textService.get('lastPageLabel') || '';

  constructor(private textService: TextServiceProvider) {
    super();
  }

  public getRangeLabel = (page: number, pageSize: number, length: number) => {
    if (length === 0 || pageSize === 0) return '-';

    const startIndex = page * pageSize;
    const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;

    return startIndex + 1 + ' - ' + endIndex + ' ' + (this.textService.get('of') || 'z') + ' ' + length;
  };
}



// WEBPACK FOOTER //
// ./src/utils/mat-pagination-i18n.ts